import React, { useState, useEffect } from "react";
import "./index.scss";
import SHU_TIAO from "@/assets/images/shutiao.png";
import {
  Toast,
  ImagePicker,
  Button,
  NoticeBar,
  Card,
  Picker,
  DatePicker,
} from "antd-mobile";
import { fileUpload, addDriverAntiepidemic } from "@/api";
import { createNonceStr, md5, getLocationSearch } from "@/utils/utils";
import { packDate } from "@/utils/getDate";
import request from "@/utils/request";
import Header from '@/components/header/common'
import qs from "qs";

const GvcProve = (props) => {
  let { history, location } = props;
  // let arr = location.search.split("?");
  // let { token } = qs.parse(arr[1]);
  let token = getLocationSearch().token;
  let appKey = "app_h5";
  let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
  let timestamp = new Date().getTime();
  let random = createNonceStr();
  let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
  let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
  const params = {
    appKey: appKey,
    timestamp: timestamp,
    random: random,
    token: token,
    sign: sign,
  };
  const handleGoGvc = () => {
    // history.push(`/gvc?token=${token}`);
    history.push(`/gvc`);
  };
  let [proveFiles, setProveFiles] = useState([]);
  let [num, setNum] = useState([]);
  let [date, setDate] = useState("");
  let [district, setDistrict] = useState([
    { label: "第一针", value: 1 },
    { label: "第二针", value: 2 },
    { label: "加强针", value: 3 },
  ]);
  const onChangeDate = (val) => {
    setDate(val);
  };
  const dateText = (val) => {
    return val ? packDate(val) : "请选择";
  };
  const onChangeNum = (val) => {
    setNum(val);
  };
  const numLabel = (val) => {
    let res = district.filter((e) => e.value == val[0]);
    return res[0].label || "请选择";
  };
  const fileUp = async (file) => {
    console.log(file, "sssss");
    Toast.loading('loading...',0,()=>{},true)
    const res = await request.post(fileUpload, file, {
      ...params,
      "Content-Type": "application/x-www-form-urlencoded",
    });
    Toast.hide()
    if (res.data.data) {
      return res.data.data.ossKey;
    }
    return false;
  };
  const onChangeProveFiles = async (files, type, index) => {
    if (files.length > 0) {
      const formData = new FormData();
      formData.append("file", files[0].file);
      formData.append("fileType", "BIZLICENT_IMG");
      let ossKey = await fileUp(formData);
      if (ossKey) {
        files[0].ossKey = ossKey;
      } else {
        Toast.offline("图片上传失败，请重新上传!");
        files = [];
      }
    }
    setProveFiles(files);
  };
  const submit = async () => {
    if (proveFiles.length < 1) {
      Toast.offline("图片未上传，请检查并重新上传!!!");
      return;
    }
    if (num.length < 1) {
      Toast.offline("接种次数未选择，请检查并修改!!!");
      return;
    }
    if (num[0] == 2 && !date) {
      Toast.offline("第二次接种时间未选择，请检查并修改!!!");
      return;
    }
    console.log(proveFiles[0].ossKey, "proveFiles[0].ossKey");
    let data = {
      antiepidemicType: 1,
      pictureUrl: proveFiles[0].ossKey,
      vaccine: num[0],
    };
    if (data.vaccine == 2) {
      data.operationDate = date;
    }
    Toast.loading("loading...", 0, () => {}, true);
    const res = await request.post(addDriverAntiepidemic, data, params);
    Toast.hide();
    if (res.data.data) {
      Toast.success("提交成功!");
      setTimeout(handleGoGvc, 2000);
    } else if (res.data.errorMsg) {
      Toast.offline(res.data.errorMsg);
    }
  };
  useEffect(() => {
    document.title = "新冠疫苗接种证明";
  }, []);

  return (
    <div className="GvcProve_box">
      <Header tit='新冠疫苗接种证明' handleGoBackHeader={handleGoGvc}></Header>
      <NoticeBar
        className="notice_bar"
        marqueeProps={{ loop: true, style: { padding: "0 0.4rem" } }}
      >
        请确保上传真实有效的信息，若上传虚假信息将可能永久封禁；如因未能提供真实信息，造成的严重后果
        本人将承担相应的法律责任
      </NoticeBar>
      <Card className="card_info">
        <Card.Header title="新冠疫苗接种证明" thumb={SHU_TIAO} />
        <Card.Body>
          <div className="card-body">
            <div className="tips">
              请上传任意一种您完成疫苗接种的证明，如：网络平台的接种记录截图，或新冠疫苗自愿接种证照片
            </div>
            <div className="img_box">
              <ImagePicker
                length="1"
                files={proveFiles}
                onChange={onChangeProveFiles}
                onImageClick={(index, fs) => console.log(index, fs)}
                selectable={proveFiles.length < 1}
              />
            </div>
            <Picker
              title="选择接种次数"
              extra="请选择"
              data={district}
              cols={1}
              value={num}
              className="forss"
              onChange={onChangeNum}
            >
              <div className="picker-box">
                <div className="left">当前已经接种:</div>
                {num.length > 0 ? (
                  <div className="right">{numLabel(num)}</div>
                ) : (
                  <div className="right">请选择</div>
                )}
              </div>
            </Picker>
            {num[0] == 2 ? (
              <DatePicker
                mode="date"
                format="YYYY-MM-DD"
                title="检测时间"
                maxDate={new Date()}
                extra="Optional"
                value={date}
                onChange={onChangeDate}
              >
                <div className="picker-box">
                  <div className="left">第二针接种时间:</div>
                  {date ? (
                    <div className="right">{dateText(date)}</div>
                  ) : (
                    <div className="right">请选择</div>
                  )}
                </div>
              </DatePicker>
            ) : null}
          </div>
        </Card.Body>
      </Card>
      <Button
        type="primary"
        className="btn"
        disabled={num.length == 0 || proveFiles.length == 0}
        onClick={submit}
      >
        确认并提交
      </Button>
    </div>
  );
};
export default GvcProve;
